import { Progress as MantineProgress } from "@mantine/core";
import styles from "./index.module.scss";

export const Progress = () => {
  return <MantineProgress value={100} animated radius={"xs"} className={styles.progress} />;
};
